<template>
  <section class="vue-tab-select">
    <section class="select-area red-bg" @click="openMenu()">
      {{ $t(currentName) }}
    </section>
    <section class="tab-menu-box" v-if="isShowMenu">
      <h2>
        <span class="text">{{ $t(title) }}</span>
        <a class="close-btn" @click="closeMenu"></a>
      </h2>
      <ul>
        <li v-for="(item, index) in list" :key="index">
          <a :class="{'active': item[selectKey] === currentValue}" @click="chooseItem(item[selectKey], item.name)" v-if="item.type !== 'link'">{{ $t(item.name) }}<em></em></a>
          <a :href="item[selectKey]" v-if="item.type === 'link'" target="_blank">{{ $t(item.name) }}<em></em>  </a>
        </li>
      </ul>
    </section>
  </section>
</template>
<script>
  export default {
    props:{
      value:{
        required:true
      },
      list: {
        type: Array
      },
      title: '',
      keyName: ''
    },
    data(){
      return{
        currentValue: this.value,
        currentName: '',
        isShowMenu: false,
        selectKey: this.keyName || 'code'
      }
    },
    mounted() {
      if(this.currentValue === undefined){
        this.currentValue = '';
      }
      this.setName();
    },
    methods: {
      openMenu(){
        this.isShowMenu = true;
        $('body').addClass('no-scroll');
      },
      closeMenu(){
        this.isShowMenu = false;
        $('body').removeClass('no-scroll');
      },
      chooseItem(code, name){
        this.currentValue = code;
        this.currentName = name;
        this.closeMenu();
        this.$emit("valueChanged", this.currentValue);
      },
      setName(){
        const [ chooseItem ] = this.list.filter((item) => { return this.currentValue === item[this.selectKey] });
        this.currentName = chooseItem ? chooseItem.name : '';
      }
    },
    watch: {
      //监听prop传的value，如果父级有变化了，将子组件的myValue也跟着变，达到父变子变的效果
      value(newVal) {
        this.currentValue = newVal;
        this.setName();
      },
      //监听myValue，如果子组件中的内容变化了，通知父级组件，将新的值告诉父级组件，我更新了，父级组件接受到值后页就跟着变了
      currentValue(newVal) {
        this.$emit('input', newVal)
      }
    }
  }
</script>
<style scoped lang="scss">
.tab-menu-box{
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1002;
  h2{
    position: relative;
    width: 100%;
    height: 65px;
    background: rgba(255,255,255,1);
    padding: 20px 0;
    text-align: center;
    line-height: 14px;
    margin: 0;
    .text{
      display: inline-block;
      color: #261A16;
      font-size: 18px;
      font-weight: 500;
      letter-spacing: 1.8px;

    }
  }
  .back-btn{
    display: block;
    width: 15px;
    height: 14px;
    background: url(../../assets/images/menuLeft.png) no-repeat left center;
    position: absolute;
    left: 30px;
    top:25px;
  }
  .close-btn{
    width: 22px;
    height: 22px;
    background: url('../../assets/images/Icon_Home_Menu_Back@2x.png') no-repeat center center;
    background-size: 100%;
    display: block;
    position: absolute;
    right:20px;
    top:22px;
  }
  ul{
    width: 100%;
    height: calc(100% - 66px);
    margin: 0;
    background: rgba(255,255,255,.9);
    padding: 20px 30px;
    li{
      height: 36px;
      text-align: center;
      margin: 20px 0;
      a{
        width: 100%;
        display: block;
        color: #261A16;
        font-size: 16px;
        letter-spacing: 1.2px;
        line-height: 16px;
        padding: 10px 0;

        background-size: 15px;
        cursor: pointer;
        em{
          width:6px;
          height: 14px;
          background: url(../../assets/images/menuRight.png) no-repeat right center ;
          position: absolute;
          right: 30px;
          margin-top: 5px;
          background-size: 100%;
        }
        &.active{
          color: #CF0902;        }
      }
    }
  }
}
.select-area {
  width: 100%;
  min-height: 55px;
  color: #CF0902;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 1.5px;
  line-height: 1.2;
  border: 0;
  padding: 15px 26px;
  background: url(../../assets/images/selectIcon.svg) no-repeat 97% center;

  &.red-bg{
    background-image: url("../../assets/images/angle-left-solid.png");
    background-position: 93% center;
    background-size: 26px auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/default/vue-tab-select.vue